import axios from 'axios';
import config from '../../config';

////////////////
///Constants
/////////////////

/**
 * The event tool services api host is read from localstorage, where it was set in the Login component
 * after determining the correct endpoint via the Version Service. See the login component
 * and https://axsteam.atlassian.net/wiki/x/iAHeSQ
 *
 * @returns {*}
 */
const getApiHost = () => {
  return localStorage.getItem('axsApiEndpoint') || config.protocol + config.api;
};
export const API_PROTOCOL = config.protocol;
export const CMS_API_HOST = config.cmsAPI;
export const SERVICES_API_HOST = config.servicesAPI;
export const CMS_API_TOKEN = config.cmsApiToken;

export const LOGIN_URL = '/auth';
export const GET_ALL_CONTEXTS_URL = '/contexts/{domain}';
export const GET_EVENTS_URL = '/events/all/{contextId}';

export const GET_PROMOTERS_URL = '/events/promoters/{ContextId}';

export const GET_CHECK_FOR_EVENT_OVERLAP_URL = '/events/{contextId}';
export const GET_EVENT_DETAILS_URL = '/events/retrievebyid/{contextId}/{id}';
export const GET_TEMPLATES_URL = '/templates/getall/{contextId}';
export const GET_TEMPLATE_URL = '/templates/retrievebyid/{contextId}/{id}';
export const SAVE_TEMPLATE = '/templates/save/';
export const DELETE_TEMPLATE = '/templates/delete/{ContextId}/{TemplateId}';
export const DEACTIVATE_TEMPLATE =
  '/templates/deactivate/{ContextId}/{TemplateId}';
export const PATCH_ACTIVATE_TEMPLATE =
  '/templates/activate/{ContextId}/{TemplateId}';
export const UPDATE_PRICECHART = '/pricechart/save';

export const GET_PRICE_CODES_PER_EVENT =
  '/pricecode/retrievebyevent/{ContextId}/{EventId}';
export const GET_DEFAULT_PRICE_LEVELS_URL = '/defaultPriceLevels';
export const GET_PRICE_CODES_FROM_TEMPLATE_URL = '/templates/{id}/priceCodes';
export const GET_ALL_VENUE_MAPS = '/venuemap/all/';
export const SEARCH_SITE_URL = '/events/retrievebyname/{contextId}/';
export const GET_SYS_PRICE_LEVELS_URL = '/pricelevel/system/{ContextId}';
export const GET_SYS_PRICE_CODES_URL =
  '/pricecode/retrievesyspricecodes/{ContextId}';
export const GET_PRICE_COMPONENT_NAMES_URL = '/pricecomponents/get/{ContextId}';

export const GET_OFFER_BY_ID =
  '/offer/retrievebyid/{ContextId}/{OfferId}/{VenueId}';
export const GET_OFFERS_URL = '/offers/{ContextId}/{Username}';

export const GET_REMAINING_OFFERS =
  '/offers/remainingtemplateoffers/{ContextId}/{EventId}/{TemplateId}';

export const GET_OUTLETS = '/sysoutlets/all/{ContextId}';
export const GET_DELIVERY_METHODS = '/deliverymethod/all/{ContextId}';
export const GET_STATUS_CODES =
  '/statuscodes/retrievebyzone/{ContextId}/{EventId}/{ZoneId}';
export const GET_PAYMENT_METHODS = '/paymentmethod/all/{ContextId}';
export const GET_EVENT_CATEGORIES = '/eventcategory/{ContextId}';
export const GET_SEASON_CATEGORIES = '/seasoncategory/{ContextId}';

export const PUBLISH_EVENT = '/event/save';
export const CREATE_CMS_EVENT = '/cmsevent/save';
export const SAVE_EVENT = '/event/save';
export const SAVE_FLASHSEATS_EVENT_SETTINGS = '/fseventconfig/update';
export const CHECK_OFFER_LOOKUP_ID = '/offer/lookupused/{ContextId}/{LookupId}	';
export const GET_ALL_FEES = '/fees/all/{ContextId}/{UserName}';
export const GET_PRICE_CHART =
  '/pricechart/retrievebyzone/{ContextId}/{EventId}/{ZoneId}';
export const CHECK_EVENT_LOOKUP = '/event/lookupused/{ContextId}/{LookupId}';
export const SAVE_OFFER = '/offers/save';
export const SAVE_AUTO_PUBLISH_OFFER = '/offers/autoPublishOffers';
export const SAVE_ZONE_SETTINGS = '/zone/save';
export const GET_PRICE_LEVELS_BY_EVENT =
  '/pricelevel/retrievebyevent/{ContextId}/{EventId}';
export const SAVE_ORIGINAL_TEMPLATE_ID =
  '/templates/saveoriginaltemplate/{ContextId}/{TemplateId}/{EventId}';
export const GET_PRINT_TEMPLATES = '/PrintTemplates/{ContextId}/{UserName}';
export const GET_PROMO_GROUPS = '/promo/groups';
export const GET_PROMO_TEMPLATES = '/promo/templates/{PromoGroupId}';
export const GET_FLASH_DEFAULTS = '/defaulteventconfig/{ContextId}/{VenueId}';

export const SEARCH_ARTISTS_URL =
  '/v1/search?types=performer&rows=25&q={artistName}';
export const SEARCH_PROMOTER_URL = `/v1/autocomplete/promoters?access_token=${CMS_API_TOKEN}&term={promoterName}`;
export const SEARCH_SITES_URL = `/v1/sites/search?access_token=${CMS_API_TOKEN}&venueId={venueId}`;
export const GET_EVENT_REVISIONS = `/v1/revisions/1/{EventId}?access_token=${CMS_API_TOKEN}`;
export const GET_PROMOTION_REVISIONS = `/v1/revisions/8/{PromotionId}?access_token=${CMS_API_TOKEN}`;
export const GET_SHORT_CODES = `/v1/shortCodes?access_token=${CMS_API_TOKEN}`;

export const GET_PRICING_AUDIT_LOG =
  '/PricingAuditlog/{ContextId}/{EventId}/{ZoneId}';
export const GET_OFFER_AUDIT_LOG = '/OfferAuditLog/{ContextId}/{OfferId}';
export const GET_AXS_MANAGER_OPTIONS = '/axsmanagers/all/{contextId}';
export const GET_VENUE_MANAGER_OPTIONS = '/venuemanagers/all/{contextId}';
export const GET_LD_FLAG_VALUE = '/core-stack-ld/{ContextId}/{Flag}';
export const GET_EMAIL_TEMPLATES = '/emailtemplates/{ContextId}';
export const GET_TAX_PROFILES = '/taxprofile/all/{ContextId}';
export const GET_REVENUE_CENTER = '/revenuecenter/all/{ContextId}';

const commonHeaders = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};

////////////////////
////API Calls
///////////////////

export const logoutAndRedirect = (err) => {
  if (
    err.response.data.ResponseStatus &&
    err.response.data.ResponseStatus.ErrorCode === 'TokenException'
  ) {
    localStorage.removeItem('axsBearerToken');
    localStorage.removeItem('axsRefreshToken');
    localStorage.removeItem('axsUserName');
    localStorage.removeItem('axsContextId');
    window.location.pathname = '/login';
  }
};

export const loginUser = (user) => {
  const authOptions = {
    method: 'POST',
    url: getApiHost() + LOGIN_URL,
    data: user,
    headers: {
      ...commonHeaders,
    },
  };
  return axios(authOptions);
};

export const loadAllContexts = (domain) => {
  const pathWithDomain = GET_ALL_CONTEXTS_URL.replace('{domain}', domain);
  const authOptions = {
    method: 'GET',
    url: getApiHost() + pathWithDomain,
    headers: {
      ...commonHeaders,
    },
  };
  return axios(authOptions);
};

export const getPromoGroups = () => {
  const requestOptions = {
    method: 'GET',
    url: getApiHost() + GET_PROMO_GROUPS,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions);
};
export const getPromoTemplates = (promoGroupId) => {
  const pathWithId = GET_PROMO_TEMPLATES.replace(
    '{PromoGroupId}',
    promoGroupId
  );
  const requestOptions = {
    method: 'GET',
    url: getApiHost() + pathWithId,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const searchEvents = (contextId, text) => {
  const pathWithContextId = SEARCH_SITE_URL.replace('{contextId}', contextId);
  const requestOptions = {
    method: 'GET',
    url: getApiHost() + pathWithContextId + encodeURIComponent(text),
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const getPriceCodesForEvent = (contextId, eventId) => {
  const pathWithId = GET_PRICE_CODES_PER_EVENT.replace(
    '{ContextId}',
    contextId
  ).replace('{EventId}', eventId);
  const requestOptions = {
    method: 'GET',
    url: getApiHost() + pathWithId,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const getEvent = (contextId, eventId) => {
  const urlWithId = GET_EVENT_DETAILS_URL.replace(
    '{contextId}',
    contextId
  ).replace('{id}', eventId);
  const requestOptions = {
    method: 'GET',
    url: getApiHost() + urlWithId,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const getEvents = (contextId, withCms) => {
  const pathWithId = GET_EVENTS_URL.replace('{contextId}', contextId);
  const flag = withCms ? true : false;
  const filter = `?includeCMSOnlyEvents=${flag}`;
  const requestOptions = {
    method: 'GET',
    url: getApiHost() + pathWithId + filter,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const getPromoters = (contextId) => {
  const pathWithId = GET_PROMOTERS_URL.replace('{ContextId}', contextId);
  const requestOptions = {
    method: 'get',
    url: getApiHost() + pathWithId,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const getCheckForEventOverlap = (venueId, startDate, contextId) => {
  const pathWithParams = GET_CHECK_FOR_EVENT_OVERLAP_URL.replace(
    '{contextId}',
    contextId
  );
  const requestOptions = {
    method: 'GET',
    params: { VenueId: venueId, StartDateTime: startDate },
    url: getApiHost() + pathWithParams,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const getTemplates = (contextId) => {
  const pathWithId = GET_TEMPLATES_URL.replace('{contextId}', contextId);
  const requestOptions = {
    method: 'GET',
    url: getApiHost() + pathWithId,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const getTemplate = (contextId, templateId) => {
  const pathWithIds = GET_TEMPLATE_URL.replace(
    '{contextId}',
    contextId
  ).replace('{id}', templateId);
  const requestOptions = {
    method: 'GET',
    url: getApiHost() + pathWithIds,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const saveTemplate = (
  contextId,
  templateName,
  categoryIds,
  eventId,
  zoneIds,
  templateZones
) => {
  const requestOptions = {
    method: 'post',
    url: getApiHost() + SAVE_TEMPLATE,
    responseType: 'json',
    data: {
      ContextId: contextId,
      EventId: eventId,
      Name: templateName,
      CategoryIds: categoryIds,
      ZoneIds: zoneIds,
      Zones: templateZones,
    },
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const updateTemplate = (
  contextId,
  templateName,
  categoryIds,
  eventId,
  templateId,
  zoneIds,
  templateZones
) => {
  const requestOptions = {
    method: 'put',
    url: getApiHost() + SAVE_TEMPLATE,
    data: {
      ContextId: contextId,
      Id: templateId,
      EventId: eventId,
      Name: templateName,
      CategoryIds: categoryIds,
      ZoneIds: zoneIds,
      Zones: templateZones,
    },
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const updatePriceCharts = (data) => {
  const requestOptions = {
    method: 'put',
    url: getApiHost() + UPDATE_PRICECHART,
    data: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const getVenueMaps = (contextId) => {
  const requestOptions = {
    method: 'get',
    url: getApiHost() + GET_ALL_VENUE_MAPS + contextId,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const getAxsManagers = (contextId) => {
  const pathWithId = GET_AXS_MANAGER_OPTIONS.replace('{contextId}', contextId);
  const requestOptions = {
    method: 'GET',
    url: getApiHost() + pathWithId,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions);
};

export const getVenueManagers = (contextId) => {
  const pathWithId = GET_VENUE_MANAGER_OPTIONS.replace(
    '{contextId}',
    contextId
  );
  const requestOptions = {
    method: 'GET',
    url: getApiHost() + pathWithId,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions);
};

export const fetchSystemPriceCodes = (contextId) => {
  const pathWithId = GET_SYS_PRICE_CODES_URL.replace('{ContextId}', contextId);
  const requestOptions = {
    method: 'get',
    url: getApiHost() + pathWithId,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const fetchSystemPriceLevels = (contextId) => {
  const pathWithId = GET_SYS_PRICE_LEVELS_URL.replace('{ContextId}', contextId);
  const requestOptions = {
    method: 'get',
    url: getApiHost() + pathWithId,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const getPriceComponentNames = (contextId) => {
  const pathWithId = GET_PRICE_COMPONENT_NAMES_URL.replace(
    '{ContextId}',
    contextId
  );
  const requestOptions = {
    method: 'get',
    url: getApiHost() + pathWithId,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions);
};

export const getOffers = (contextId, username) => {
  const pathWithId = GET_OFFERS_URL.replace('{ContextId}', contextId).replace(
    '{Username}',
    username
  );
  const requestOptions = {
    method: 'GET',
    url: getApiHost() + pathWithId,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const getRemainingOffers = (contextId, eventId, templateId) => {
  const path = GET_REMAINING_OFFERS.replace('{ContextId}', contextId)
    .replace('{EventId}', eventId)
    .replace('{TemplateId}', templateId);
  const requestOptions = {
    method: 'GET',
    url: getApiHost() + path,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const getOfferById = (contextId, offerId, venueId) => {
  const pathWithId = GET_OFFER_BY_ID.replace('{ContextId}', contextId)
    .replace('{OfferId}', offerId)
    .replace('{VenueId}', venueId);
  const requestOptions = {
    method: 'get',
    url: getApiHost() + pathWithId,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const getOutlets = (contextId) => {
  const pathWithId = GET_OUTLETS.replace('{ContextId}', contextId);
  const requestOptions = {
    method: 'get',
    url: getApiHost() + pathWithId,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const getDeliveryMethods = (contextId) => {
  const pathWithId = GET_DELIVERY_METHODS.replace('{ContextId}', contextId);
  const requestOptions = {
    method: 'get',
    url: getApiHost() + pathWithId,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const getEventCategories = (contextId) => {
  const pathWithId = GET_EVENT_CATEGORIES.replace('{ContextId}', contextId);
  const requestOptions = {
    method: 'get',
    url: getApiHost() + pathWithId,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };

  return axios(requestOptions).catch(logoutAndRedirect);
};

export const getSeasonCategories = (contextId) => {
  const pathWithId = GET_SEASON_CATEGORIES.replace('{ContextId}', contextId);
  const requestOptions = {
    method: 'get',
    url: getApiHost() + pathWithId,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };

  return axios(requestOptions).catch(logoutAndRedirect);
};

export const publishEvent = (data) => {
  const requestOptions = {
    method: 'post',
    url: getApiHost() + PUBLISH_EVENT,
    data: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  const apiPostResponse = axios(requestOptions);
  return apiPostResponse;
};

export const createCMSEvent = (data) => {
  const requestOptions = {
    method: 'post',
    url: getApiHost() + CREATE_CMS_EVENT,
    data: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const saveEvent = (data) => {
  const requestOptions = {
    method: 'put',
    url: getApiHost() + SAVE_EVENT,
    data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const saveFlashSeatSettings = (data) => {
  const requestOptions = {
    method: 'put',
    url: getApiHost() + SAVE_FLASHSEATS_EVENT_SETTINGS,
    data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const saveZoneSettings = (data) => {
  const requestOptions = {
    method: 'patch',
    url: getApiHost() + SAVE_ZONE_SETTINGS,
    data: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const getStatusCodes = (contextId, eventId, zoneId) => {
  const pathWithId = GET_STATUS_CODES.replace('{ContextId}', contextId)
    .replace('{EventId}', eventId)
    .replace('{ZoneId}', zoneId);
  const requestOptions = {
    method: 'get',
    url: getApiHost() + pathWithId,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions);
};

export const getPaymentMethods = (contextId) => {
  const pathWithId = GET_PAYMENT_METHODS.replace('{ContextId}', contextId);
  const requestOptions = {
    method: 'get',
    url: getApiHost() + pathWithId,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions);
};

export const getAllFees = (contextId, userName) => {
  const pathWithValues = GET_ALL_FEES.replace('{ContextId}', contextId).replace(
    '{UserName}',
    userName
  );
  const requestOptions = {
    method: 'get',
    url: getApiHost() + pathWithValues,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const deleteTemplate = (contextId, templateId) => {
  const pathWithId = DELETE_TEMPLATE.replace('{ContextId}', contextId).replace(
    '{TemplateId}',
    templateId
  );
  const requestOptions = {
    method: 'delete',
    url: getApiHost() + pathWithId,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const patchDeactivateTemplate = (contextId, templateId) => {
  const pathWithId = DEACTIVATE_TEMPLATE.replace(
    '{ContextId}',
    contextId
  ).replace('{TemplateId}', templateId);
  const requestOptions = {
    method: 'patch',
    url: getApiHost() + pathWithId,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions);
};
export const patchActivateTemplate = (contextId, templateId) => {
  const pathWithId = PATCH_ACTIVATE_TEMPLATE.replace(
    '{ContextId}',
    contextId
  ).replace('{TemplateId}', templateId);
  const requestOptions = {
    method: 'patch',
    url: getApiHost() + pathWithId,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions);
};

export const getPriceChart = (contextId, eventId, zoneId) => {
  const pathWithId = GET_PRICE_CHART.replace('{ContextId}', contextId)
    .replace('{EventId}', eventId)
    .replace('{ZoneId}', zoneId);
  const requestOptions = {
    method: 'get',
    url: getApiHost() + pathWithId,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const checkEventLookupId = (contextId, lookupId) => {
  const pathWithId = CHECK_EVENT_LOOKUP.replace(
    '{ContextId}',
    contextId
  ).replace('{LookupId}', lookupId);
  const requestOptions = {
    method: 'get',
    url: getApiHost() + pathWithId,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const validateOfferLookupId = (contextId, lookupId) => {
  const pathWithId = CHECK_OFFER_LOOKUP_ID.replace(
    '{ContextId}',
    contextId
  ).replace('{LookupId}', lookupId);
  const requestOptions = {
    method: 'get',
    url: getApiHost() + pathWithId,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions);
};

export const saveOffer = (
  contextId,
  AXSEvent,
  venueId,
  eventId,
  zoneId,
  offers,
  userName
) => {
  const requestOptions = {
    method: 'post',
    url: getApiHost() + SAVE_OFFER,
    data: {
      ContextId: contextId,
      VenueId: venueId,
      AXSEvent: AXSEvent,
      EventId: eventId,
      ZoneId: zoneId,
      Offers: offers,
      UserName: userName,
    },
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const saveAutoPublishOffer = (
  contextId,
  AXSEvent,
  venueId,
  eventId,
  zones,
  userName
) => {
  const requestOptions = {
    method: 'post',
    url: getApiHost() + SAVE_AUTO_PUBLISH_OFFER,
    data: {
      ContextId: contextId,
      VenueId: venueId,
      AXSEvent: AXSEvent,
      EventId: eventId,
      Zones: zones,
      UserName: userName,
    },
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const getPriceLevelsByEvent = (contextId, eventId) => {
  const pathWithIds = GET_PRICE_LEVELS_BY_EVENT.replace(
    '{ContextId}',
    contextId
  ).replace('{EventId}', eventId);
  const requestOptions = {
    method: 'get',
    url: getApiHost() + pathWithIds,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const saveOriginalTemplate = (contextId, templateId, eventId) => {
  const pathWithIds = SAVE_ORIGINAL_TEMPLATE_ID.replace(
    '{ContextId}',
    contextId
  )
    .replace('{TemplateId}', templateId)
    .replace('{EventId}', eventId);
  const requestOptions = {
    method: 'post',
    url: getApiHost() + pathWithIds,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const getPrintTemplates = (contextId, userName) => {
  const pathWithIds = GET_PRINT_TEMPLATES.replace(
    '{ContextId}',
    contextId
  ).replace('{UserName}', userName);
  const requestOptions = {
    method: 'get',
    url: getApiHost() + pathWithIds,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const searchArtists = (artistName) => {
  const pathWithId = SEARCH_ARTISTS_URL.replace('{artistName}', artistName);
  const requestOptions = {
    method: 'get',
    url: API_PROTOCOL + SERVICES_API_HOST + pathWithId,
    headers: {
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const searchPromoters = (promoterName) => {
  const pathWithId = SEARCH_PROMOTER_URL.replace(
    '{promoterName}',
    promoterName
  );
  const requestOptions = {
    method: 'get',
    url: API_PROTOCOL + CMS_API_HOST + pathWithId,
    headers: {
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const getShortCodes = () => {
  const requestOptions = {
    method: 'GET',
    url: API_PROTOCOL + CMS_API_HOST + GET_SHORT_CODES,
    headers: {
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const getFlashEventDefaults = (contextId, venueId) => {
  const pathWithIds = GET_FLASH_DEFAULTS.replace(
    '{ContextId}',
    contextId
  ).replace('{VenueId}', venueId);
  const requestOptions = {
    method: 'get',
    url: getApiHost() + pathWithIds,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const searchSites = (venueId) => {
  const pathWithId = SEARCH_SITES_URL.replace('{venueId}', venueId);
  const requestOptions = {
    method: 'get',
    url: API_PROTOCOL + CMS_API_HOST + pathWithId,
    headers: {
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const getPricingAuditLog = (contextId, eventId, zoneId) => {
  const pathWithId = GET_PRICING_AUDIT_LOG.replace('{ContextId}', contextId)
    .replace('{EventId}', eventId)
    .replace('{ZoneId}', zoneId);
  const requestOptions = {
    method: 'GET',
    url: getApiHost() + pathWithId,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const getEventRevisions = (eventId) => {
  const pathWithId = GET_EVENT_REVISIONS.replace('{EventId}', eventId);
  const requestOptions = {
    method: 'get',
    url: API_PROTOCOL + CMS_API_HOST + pathWithId,
    headers: {
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const getOfferAuditLog = (contextId, offerId) => {
  const pathWithId = GET_OFFER_AUDIT_LOG.replace(
    '{ContextId}',
    contextId
  ).replace('{OfferId}', offerId);
  const requestOptions = {
    method: 'GET',
    url: getApiHost() + pathWithId,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const getPromotionRevisions = (promotionId) => {
  const pathWithId = GET_PROMOTION_REVISIONS.replace(
    '{PromotionId}',
    promotionId
  );
  const requestOptions = {
    method: 'get',
    url: API_PROTOCOL + CMS_API_HOST + pathWithId,
    headers: {
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const getLDFlagValue = (contextId, flag) => {
  const path = GET_LD_FLAG_VALUE.replace('{ContextId}', contextId).replace(
    '{Flag}',
    flag
  );
  const requestOptions = {
    method: 'GET',
    url: getApiHost() + path,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions).catch(logoutAndRedirect);
};

export const getEmailTemplates = (contextId) => {
  const pathWithId = GET_EMAIL_TEMPLATES.replace('{ContextId}', contextId);
  const requestOptions = {
    method: 'GET',
    url: getApiHost() + pathWithId,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions);
};

export const getTaxProfiles = (contextId) => {
  const pathWithId = GET_TAX_PROFILES.replace('{ContextId}', contextId);
  const requestOptions = {
    method: 'GET',
    url: getApiHost() + pathWithId,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions);
};

export const getRevenueCenter = (contextId) => {
  const pathWithId = GET_REVENUE_CENTER.replace('{ContextId}', contextId);
  const requestOptions = {
    method: 'GET',
    url: getApiHost() + pathWithId,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('axsBearerToken')}`,
      ...commonHeaders,
    },
  };
  return axios(requestOptions);
};



// WEBPACK FOOTER //
// ./src/api/ApiManager.js